import React, { useState, useRef,useCallback,useEffect } from "react";
import { eventService } from "../lib/api/event";
import MainHeader from "../pages/MainHeader";
import moment from "moment";
import PdfViewer from "../../src/admin/PdfViewer"
import { serverUrl, serverImgUrl } from '../config/constants';
export default function UpcomingEvents() {



  const [events, setEvents] = useState<any[]>([]);

const getUpComingEvents = useCallback(async () => {
    try {
      const { data } = await eventService.getUpComingEvents();
      setEvents(data);
    } catch (err) {
      console.error("dropDown error", err);
    }
  }, []);


  useEffect(() => {
    getUpComingEvents();
  }, []);

  return (
    <>
    <MainHeader/>
    <div className="container" style={{ paddingTop: "80px" }}>
      <table className="table table-bordered">
        <thead className="table-primary">
          <tr>
            <th>S.No</th>
            <th>Organisation Name</th>
            <th>Event Type</th>
            <th>Topic</th>
            <th>Event Dates</th>
            <th>Venue</th>
            <th>Brochure</th>
          </tr>
        </thead>
        <tbody>
          {events&&events.map((e, i) => (
            <tr key={e.id}>
              <td>{i + 1}</td>
              <td>{e.organizationName}</td>
              <td>{e.eventType}</td>
              <td>{e.topic}</td>
              <td>
                {moment(e.startDate).format("DD-MM-YYYY")}
                 <br /> {moment(e.endDate).format("DD-MM-YYYY")} 
              </td>
              <td>{e.venue}</td>
              <td>
                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                      {e.broucherName &&
                                        <div className="col">
                                          <div className="drag-img-box d-flex align-items-center justify-content-center">
                                            <p className="d-flex align-items-center">{<PdfViewer fileUrl={serverImgUrl + '/event/' + e.broucherName} />}
                                            </p>
                                          </div>
                                        </div>}
                                    </div>
              
                                  </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </>
  );
}
